import type { Company } from '@/features/dashboard/data/claudeMockData';

/**
 * Construiește un Company sintetic pentru `CompanyBadge` folosind datele
 * venite din backend (companyName/companyId). Aceeași strategie ca în
 * dashboard / containers / bills.
 */
export function buildCompanyForBadge(name: string, id: number): Company | undefined {
  if (!name) return undefined;
  const palette = ['#1e6bd6', '#0c8a5b', '#b6500f', '#7a3aa8', '#0f7a8a', '#c0392b'];
  const color = palette[id % palette.length] || palette[0];
  const short =
    name
      .split(/\s+/)
      .map((p) => p.charAt(0).toUpperCase())
      .join('')
      .slice(0, 3) || name.slice(0, 3).toUpperCase();
  return { id: `co_${id}`, name, short, color, vat: '' };
}
